import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { AllLocation } from "constants/all-location";
import { bottomSheetModalState, campaignInfoState } from "state";
import { useRecoilState } from "recoil";
import { CampaignInfo } from "ztypes/campaign-info";
import { TLocation } from "ztypes/common";
import IconSearch from "icons/icon-search";
import IconCircleChecked from "icons/icon-circle-checked";
import IconCircle from "icons/icon-circle";
import IconClose from "icons/icon-close/icon-close";
import toLowerCaseNonAccentVietnamese from "utils/toLowerCaseNonAccentVietnamese";

const BottomSheetModel: React.FC<{}> = () => {
  const [isOpenBottomSheet, setIsOpenBottomSheet] = useRecoilState<boolean>(
    bottomSheetModalState
  );
  const [formCondition, setFormCondition] =
    useRecoilState<CampaignInfo>(campaignInfoState);
  const [locationList, setLocationList] = useState<TLocation[]>(
    formCondition.location
  );
  const [textSearch, setTextSearch] = useState<string>("");
  const [isShowBottomBtn, setShowBottomBtn] = useState<boolean>(true);
  const [currentDisplay, setCurrentDislay] = useState<any>(AllLocation);

  const handleChangeInput = (textSearch: string) => {
    setTextSearch(textSearch);
    const searchString = textSearch.trim();
    if (!searchString || searchString.length == 0) {
      setCurrentDislay([]);
      return;
    }
    const searchLocation: any[] = [];
    Object.keys(AllLocation).map((key, index) => {
      const proviceName = toLowerCaseNonAccentVietnamese(
        AllLocation[index].name.toLowerCase()
      );
      if (proviceName.includes(toLowerCaseNonAccentVietnamese(searchString))) {
        const temp = AllLocation[index];
        searchLocation.push(temp);
      }
    });
    setCurrentDislay(searchLocation);
  };

  const handleSelectLocation = (id: number) => {
    if (id == TLocation.ALL) {
      setLocationList([0]);
      return;
    }
    let newLocation: number[] = [...locationList];
    newLocation = newLocation.filter((value) => value != TLocation.ALL);
    const idx = newLocation.indexOf(id);
    if (idx >= 0) {
      newLocation.splice(idx, 1);
    } else {
      newLocation = [...newLocation, id];
    }
    if (!newLocation || newLocation.length == 0) {
      newLocation = [0];
    }
    setLocationList(newLocation);
  };

  const handleCloseBottomSheet = (e: any) => {
    e.stopPropagation();
    if (!document.getElementById("bottom-sheet")?.contains(e.target)) {
      handleCloseSearch();
      setLocationList(formCondition.location);
      setIsOpenBottomSheet(false);
    }
  };

  const handleCancelSelectLocation = () => {
    setLocationList(formCondition.location);
    setIsOpenBottomSheet(false);
  };

  const handleSaveLocation = () => {
    setFormCondition((currState) => ({
      ...currState,
      location: locationList,
    }));
    handleCloseSearch();
    setIsOpenBottomSheet(false);
  };

  const handleCloseSearch = () => {
    setTextSearch("");
    setCurrentDislay(AllLocation);
  };

  const data = (
    <div
      className="relative z-50 h-screen w-full backdrop-brightness-[.3]"
      onClick={(e) => handleCloseBottomSheet(e)}
    >
      <div
        id="bottom-sheet"
        className="h-3/4  top-1/4 fixed flex flex-col flex-grow pt-4 px-4 w-full rounded-tl-2xl rounded-tr-2xl bg-white"
      >
        <div className="flex flex-col space-y-4">
          <div className="my-4 flex flex-row">
            <div
              className="mt-[1px] fixed flex font-normal text-[14px] leading-[18px] text-gray-500"
              onClick={handleCancelSelectLocation}
            >
              Hủy
            </div>
            <div className="m-auto font-medium text-[16px] leading-[22px]">
              {`Vị trí (${locationList.length})`}
            </div>
          </div>
          <div className="px-2 py-1.5 flex flex-row space-x-2 items-center border border-solid rounded-lg border-gray-200">
            <IconSearch className="w-5 h-5" />
            <input
              type="text"
              value={textSearch}
              className="w-full font-normal text-[14px] leading-[20px] text-gray-400 outline-none"
              placeholder="Tìm kiếm trong Việt Nam"
              onChange={(e) => handleChangeInput(e.target.value)}
              onFocus={(e) => {
                setShowBottomBtn(false);
                handleChangeInput(e.target.value);
              }}
              onBlur={(e) => {
                setShowBottomBtn(true);
                if (!e.target.value) {
                  setCurrentDislay(AllLocation);
                }
              }}
            />
            {textSearch && textSearch.length > 0 && (
              <IconClose onClick={() => handleCloseSearch()} />
            )}
          </div>
        </div>
        <div className="my-4 flex flex-grow overflow-y-scroll  [&::-webkit-scrollbar]:hidden">
          <div className="w-full flex flex-col space-y-4 ">
            {Object.keys(currentDisplay).map((location, index) => (
              <div
                key={index}
                className="flex flex-row justify-between"
                onClick={() => handleSelectLocation(currentDisplay[index].id)}
              >
                <div className="font-normal text-[15px] leading-[20px]">
                  {currentDisplay[index].name}
                </div>
                {locationList.includes(currentDisplay[index].id) ? (
                  <IconCircleChecked />
                ) : (
                  <IconCircle />
                )}
              </div>
            ))}
          </div>
        </div>
        {isShowBottomBtn && (
          <div
            className="mb-4 h-10 flex items-center justify-center rounded-[100px] px-6 py-2 font-medium text-white text-[15px] leading-[20px] bg-blue-600"
            onClick={handleSaveLocation}
          >
            Lưu
          </div>
        )}
      </div>
    </div>
  );
  return <>{isOpenBottomSheet && createPortal(data, document.body)}</>;
};

export default BottomSheetModel;
